import { execute } from '@/api/execute'
import { GET, PUT, POST } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'manager/farms'
const ENDPOINT_V2 = 'v2/manager/farms'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/dashboard/`, params))
  },
  listV2 (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT_V2}/dashboard/`, params))
  },

  create (payload) {
    return execute(POST, `${ENDPOINT}/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  }
}
